import request from '@/CommonDP/utils/request';
// 绘图仪配置文件
export default {
  uploadPlotterConfig(params) {
    return request
      .post(`/plotterPrint/uploadPlotterConfig`, params)
      .then((res) => res);
  },

  uploadPlotterModelParameter(params) {
    return request
      .post(`/plotterPrint/uploadPlotterModelParameter`, params)
      .then((res) => res);
  },
  uploadPrintStyle(params) {
    return request
      .post(`/plotterPrint/uploadPrintStyle`, params)
      .then((res) => res);
  },

  queryPlotterConfigList(enterpriseId) {
    return request
      .get(
        `/plotterPrint/queryPlotterConfigList?enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  queryPlotterModelParameterList(enterpriseId) {
    return request
      .get(
        `/plotterPrint/queryPlotterModelParameterList?enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  queryPrintStyleList(enterpriseId) {
    return request
      .get(
        `/plotterPrint/queryPrintStyleList?enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },

  deletePlotterConfig(id) {
    return request
      .get(`/plotterPrint/deletePlotterConfig?id=${id}`)
      .then((res) => res);
  },
  deletePlotterModelParameter(id) {
    return request
      .get(`/plotterPrint/deletePlotterModelParameter?id=${id}`)
      .then((res) => res);
  },
  deletePrintStyle(id) {
    return request
      .get(`/plotterPrint/deletePrintStyle?id=${id}`)
      .then((res) => res);
  },
  downloadPlotterConfig(fileId) {
    return request({
      url: `/plotterPrint/downloadPlotterConfig?fileId=${fileId}`,
      method: 'get',
      responseType: 'blob'
    });
  }
};
